var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-pagination-table',{attrs:{"entity-url":"users","title":"Users","headers":_vm.headers,"banner":"https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg","edit-route-name":"UsersEdit","create-route-name":"UsersNew"}})}
var staticRenderFns = []

export { render, staticRenderFns }